/*
 * Module to handle category values of a single category
 */

define([
  "marionette",
  "messaging/messenger",
  "./categoryValuesView",
  "modules/authoringAdmin/categories/category/topicsUsingCategoryModal/topicsUsingCategoryListModel",
  "modules/authoringAdmin/categories/category/topicsUsingCategoryModal/topicsUsingCategoryModalModule",
], function (
  Marionette,
  Messenger,
  CategoryValuesView,
  TopicsUsingCategoryModel,
  TopicsUsingCategoryModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "categoryValues";
      this.region = options.region;
      this.pendingNewEntry = false; //true if there is a blank new entry in the collection
      this._setUpVents();
    },
    show: function (values) {
      this.categoryValues = values;
      this.categoryValues.selectedLanguage = Messenger.reqres.request("kb:selected:language");
      this.categoryValues.selectedLanguageId = this.categoryValues.selectedLanguage.get("id");
      this._setUpView();
      this.showRegion(this.view, { loading: true });
    },
    emptyError: function (errorMessage) {
      this.view.emptyError(errorMessage);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "change:kb:selected:language",
        function (selectedLanguage) {
          this.categoryValues.selectedLanguage = selectedLanguage;
          this.categoryValues.selectedLanguageId = selectedLanguage.get("id");
          this.view.render();
        },
        this,
      );
    },
    _setUpView: function () {
      this.view = new CategoryValuesView.categoryValuesView({ collection: this.categoryValues });

      //handle removing an entry
      this.view.on(
        "itemview:delete:value",
        function (deleteView) {
          const catValueId = deleteView.model.get("categoryValueId");
          const categoryId = this.categoryValues.category.id;
          const kbId = this.categoryValues.category.get("knowledgeBaseId");
          const categoryValueTopicUsage = Messenger.reqres.request(
            "fetch:kb:categoryValue:topicUsage",
            kbId,
            categoryId,
            catValueId,
          );
          categoryValueTopicUsage.onSynced(function () {
            if (categoryValueTopicUsage.get("usedByTopic")) {
              this.topicsUsingCategory = Messenger.reqres.request(
                "fetch:topics:using:category",
                kbId,
                null,
                catValueId,
              );
              this.topicsUsingCategory.onSynced(() => {
                if (this.topicsUsingCategory && this.topicsUsingCategory.length > 0) {
                  Messenger.vent.trigger(
                    "show:modal",
                    TopicsUsingCategoryModalModule,
                    {
                      categoryValueModel: deleteView.model,
                    },
                    this.topicsUsingCategory,
                    {
                      title: "admin.categories.values.topicsUsingCategoryValueList.title",
                      closeOnBackgroundClick: false,
                      modalWidth: "900px",
                      modalHeight: "600px",
                      trackInteraction: {
                        action: "Topics Using Category Value",
                        id: [categoryId, deleteView.model.id],
                        idType: ["Category", "Category Value"],
                        object: "Category Value",
                      },
                    },
                  );
                } else {
                  // there are no topics using this category code.
                  // Open a message dialog and ask user to confirm deletion of category value
                  Messenger.yesNoDialog(
                    "topic.categories.deleteDialog",
                    {
                      yes: function () {
                        Messenger.vent.trigger("track:interaction", {
                          action: "Delete Category Value",
                          id: deleteView.model.id,
                          idType: "Category Value",
                          object: "Category Value",
                          source: "Category Values",
                        });
                        deleteView.model.deleteModel();
                        Messenger.vent.trigger("cancel:textbox");
                      },
                    },
                    this,
                  );
                }
              });
            } else {
              // There are no topics using this category value.
              Messenger.yesNoDialog(
                "admin.categories.values.confirmDelete",
                {
                  yes: function () {
                    Messenger.vent.trigger("track:interaction", {
                      action: "Delete Category Value",
                      id: deleteView.model.id,
                      idType: "Category Value",
                      object: "Category Value",
                      source: "Category Values",
                    });
                    deleteView.model.deleteModel();
                    Messenger.vent.trigger("cancel:textbox");
                  },
                },
                this,
              );
            }
          }, this);
        },
        this,
      );

      //handle adding a new entry
      this.view.on(
        "add:value",
        function () {
          //only add a new entry if there isn't an existing new entry open and we can close the current textbox
          if (!this.pendingNewEntry && Messenger.reqres.request("save:textbox")) {
            this.pendingNewEntry = true; //created new blank entry
            console.log("add value");
            this.newValue = this.categoryValues.addNewValue();
            //if we cancel out the field for the new entry, remove it from the collection
            this.newValue.once(
              "cancel",
              function () {
                if (this.pendingNewEntry) {
                  //only remove entry if it still pending (enter has not been clicked)
                  console.log("cancel entry");
                  this.categoryValues.remove(this.newValue);
                  this.pendingNewEntry = false; //new entry is gone, so we can add another new one
                }
              },
              this,
            );
            //if the new entry gets data written to it, it's no longer pending
            this.newValue.once(
              "enter",
              function () {
                console.log("filled out");
                this.pendingNewEntry = false; //new entry is properly filled out, so we can add another blank one
              },
              this,
            );
            //get view for this entry
            const newView = this.view.children.findByModel(this.newValue);
            newView.enableTextbox("#value");
            newView.enableTextbox("#valueDescription");
          }
        },
        this,
      );
    },
  });
});
